import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const userDocumentsFetchStatus = createSelector(
  [(store: RootState) => store.userShow.userDocumentsFetchStatus],
  (data) => data
);
